import logo from '../../assets/aakash-logo.png'
import styles from './LoginLhs.module.css'
import { getExamConfig, getExamType } from 'utils/common';

const LoginLhs = () => {
    const examType = getExamType()
    const domainConfig = getExamConfig(examType)
    const { loginImage, loginImageText } = domainConfig?.loginTemplate

    return (
        <div className={`${styles.lhsWrapper} col-md-6`}>
            <div className={styles.login1} style={{ backgroundImage: `url(${loginImage})` }}>
                <div className={styles.welcome}>
                    <img src={logo} className={styles.logo} alt='logo' />
                    <p className={styles.lhsText}>
                        {loginImageText}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default LoginLhs
